<div fxLayout="row" fxLayoutAlign="space-between top">
  <span mat-dialog-title>{{ 'vehicles.vehicleDeactivationDialog.headline' | translate }}</span>
  <button mat-icon-button [mat-dialog-close]="false">
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>
<div>
  <mat-dialog-content>
    {{ 'vehicles.vehicleDeactivationDialog.text' | translate }}

    <div class="confirmation-data">
      <div>{{ 'vehicles.licensePlate' | translate }}:</div>
      <div>{{ data.vehicle.licensePlate }}</div>
      <div>{{ 'vehicles.licenseClass'  | translate }}:</div>
      <div>{{ data.vehicle.licenseClass | licenseClass | async  }}</div>
      <div>{{ 'vehicles.description' | translate }}:</div>
      <div>{{ data.vehicle.description }}</div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      <mat-icon>check</mat-icon>
      {{ 'core.confirmBtn' | translate }}
    </button>
    <button mat-raised-button [mat-dialog-close]="false" color="primary">
      <mat-icon>close</mat-icon>
      {{ 'core.cancelBtn' | translate }}
    </button>
  </mat-dialog-actions>
</div>

